import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import CloseIcon from '../../assets/icons/CloseIcon';
import { CustomButton } from '../UI/CustomButton';
import useStyles from './styles';

interface JoinNowModalProps {
  isLoggedIn: boolean;
  handleClose: () => void;
}

const JoinNowModal: React.FC<JoinNowModalProps> = React.forwardRef(
  ({ handleClose, isLoggedIn }, ref: React.Ref<HTMLDivElement>) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const location = useLocation();

    return (
      <div tabIndex={-1} className={classes.wrapper} ref={ref}>
        <Box className={classes.container} data-testid="joinNowModal">
          <CloseIcon
            className={classes.closeBtn}
            onClick={handleClose}
            data-testid="closeJoinNowModal"
          />
          <Typography variant="h2" className={classes.title} data-testid="joinModalTitle">
            {t(isLoggedIn ? 'button.subscribeNow' : 'button.signUpNow')}
          </Typography>
          <Typography className={classes.text}>{t('page.video.accessFreeTrial')}</Typography>
          <Box className={classes.buttonsWrapper}>
            {isLoggedIn ? (
              <Link to="/pricing" data-testid="joinModalStartFreeTrial">
                <CustomButton btnClass={classes.joinBtn}>{t('button.startFreeTrial')}</CustomButton>
              </Link>
            ) : (
              <>
                <Link to="/pricing" data-testid="joinModalStartFreeTrial">
                  <CustomButton btnClass={classes.joinBtn}>
                    {t('button.startFreeTrial')}
                  </CustomButton>
                </Link>
                <Link
                  to={{
                    pathname: '/login',
                    state: { prevPath: location.pathname, prevSearch: location.search },
                  }}
                  data-testid="joinModalLogin"
                >
                  <CustomButton btnClass={classes.loginBtn} color="secondary" variant="contained">
                    {t('button.logIn')}
                  </CustomButton>
                </Link>
              </>
            )}
          </Box>
        </Box>
      </div>
    );
  },
);

export default JoinNowModal;
